import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const daysUntil = (iso) => {
  const due = new Date(iso.slice(0, 10) + "T00:00:00");
  const now = new Date(todayStr() + "T00:00:00");
  return Math.round((due - now) / 86400000);
};

export const urgencyColor = (days) => {
  if (days < 0) return "bg-black text-white";
  if (days <= 2) return "bg-[#FF6B6B] text-white";
  if (days <= 7) return "bg-[#FFE066] text-black";
  return "bg-[#51CF66] text-black";
};

export const authHeader = () => {
  const t = localStorage.getItem("ss_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ss_token");
  if (t && !config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const url = e.config?.url || "";
    const status = e.response?.status;
    if (status === 401 && !url.includes("/auth/") && !url.includes("/parent/")) {
      localStorage.removeItem("ss_token");
      if (window.location.pathname !== "/auth") window.location.href = "/auth";
    }
    if (status === 402 && window.location.pathname !== "/billing") {
      window.location.href = "/billing";
    }
    return Promise.reject(e);
  }
);
